import { render, staticRenderFns } from "./GetCustomerVisitsNotes.vue?vue&type=template&id=04e071a6&scoped=true&"
import script from "./GetCustomerVisitsNotes.vue?vue&type=script&lang=js&"
export * from "./GetCustomerVisitsNotes.vue?vue&type=script&lang=js&"
import style0 from "./GetCustomerVisitsNotes.vue?vue&type=style&index=0&id=04e071a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e071a6",
  null
  
)

export default component.exports